import IBModuleApi from "../../../api/rolecatalogAPI";
import { urlContexts } from "../../../constants";

export const getProtocols = async () => {
  const { data } = await IBModuleApi.get(
    `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/protocol`
  );

  return data;
};


export const createProtocols = async (createInfo: any) => {
  const { data } = await IBModuleApi.post(
    `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/protocol`,
    createInfo
  );

  return data;
};

export const updateProtocols = async (updateInfo: any) => {
  const { data } = await IBModuleApi.put(
    `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/protocol/${updateInfo?.id}`,
    {
      ...updateInfo,
      id: undefined,
    }
  );

  return data;
};

export const deleteProtocols = async (deleteInfo: any) => {
  const { data } = await IBModuleApi.delete(
    `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/protocol/${deleteInfo?.id}`
  );

  return data;
};

export const reactiveProtocols = async (reactiveInfo: any) => {
  const { data } = await IBModuleApi.put(
    `${process.env['REACT_APP_ROLES_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.roles}/iuvibanking-console-api-role/rest/1.0/protocol/${reactiveInfo?.id}/reactivate`
  );

  return data;
};
